import React from 'react';
import './Page.scss'

const Page = () => {
  return (
    <section className='main'>
      <h1>Welcome!</h1>
      <p className='main__blurb'>
        In today's stress filled world filled with uncertainties, many people find themselves needing the additional support of therapy. Therapy is not reserved for those that cannot function, rather it serves as a buffer to help people overcome difficult areas and times in their lives by learning to verbalize their feelings, needs and blind spots. Therapy can help propel you to go onto even further heights by overcoming challenges with the help and support of a professional.
      </p>
    </section>
  );
};

export default Page;